export const getAdminApi = (defaultSeasons: true | undefined) => {
  if (defaultSeasons !== undefined) {
    return "admin/";
  }
  return "";
};



// WEBPACK FOOTER //
// ./src/pages/director/seasons/seasonsPage/utils/getAdminApi/getAdminApi.ts